.media-minimal-skin .media-thumbnail {
  position: relative;
  pointer-events: none;
  background-color: oklch(0 0 0 / 0.9);
  border-radius: calc(var(--media-spacing) * 2);

  &::after {
    position: absolute;
    inset: 0;
    content: "";
    border-radius: inherit;
    box-shadow:
      0 0 0 1px oklch(0 0 0 / 0.05),
      0 1px 3px 0 oklch(0 0 0 / 0.2),
      0 1px 2px -1px oklch(0 0 0 / 0.2);
  }

  .media-thumbnail__image {
    position: relative;
    display: block;
    max-width: var(--media-thumbnail-max-width);
    max-height: var(--media-thumbnail-max-height);
    overflow: clip;
    border-radius: inherit;
  }

  .media-thumbnail__spinner {
    position: absolute;
    top: 50%;
    left: 50%;
    opacity: 0;
    translate: -50% -50%;
  }

  .media-thumbnail__image,
  .media-thumbnail__spinner {
    transition: opacity 150ms ease-out;
  }

  &:not(:has(.media-thumbnail__image[data-loading])) {
    .media-thumbnail__spinner {
      --media-spinner-animation: none;
    }
  }

  @media (prefers-reduced-motion: reduce) {
    --media-spinner-animation: none;
  }

  &:has(.media-thumbnail__image[data-loading]) {
    width: var(--media-thumbnail-max-width);
    max-width: 100%;
    aspect-ratio: 16 / 9;
    overflow: hidden;

    .media-thumbnail__image {
      opacity: 0;
    }
    .media-thumbnail__spinner {
      opacity: 1;
    }
  }
}
